<template>
  <div>
    {{teacher.userId}}  /  {{teacher.name}}  /  {{teacher.email}}<br>
    {{birthDate}} <br>
    {{teacher.gender}} / {{teacher.married}}<br>
    {{cellPhone}}<br>
    {{teacher.educationLevel}}<br>
    {{teacher.address}}<br>
    <mdb-btn icon="list" @click="$emit('change-mode', 'LIST')"> 돌아가기</mdb-btn>
  </div>
</template>
<script>
import { mdbIcon, mdbBtn } from 'mdbvue';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  name: 'Staff',
  components: { mdbBtn },
  props: ['teacher'],
  data: () => ({
  }),
  computed: {
    cellPhone () {
      const ph = this.teacher.cellPhone
      return ph.number1 + '-' + ph.number2 + '-' + ph.number3;
    },
    birthDate () {
      const birth = this.teacher.birthDate
      return birth.year + '-' + ('00' + birth.month).slice(-2) + '-' + ('00' + birth.date).slice(-2);
    }
  },
  methods: {
    ...mapMutations([]),
    ...mapActions([])
  }
}
</script>
